define("shared/components/shared/social/facebook-modal", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _hasRequiredTasks;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{this.closeModal}} @focusTrap={{true}} as |modal|>
    <modal.card class="o--modalCard--narrow">
      <modal.card-header>
        <h2 class="o--modalHeader__title">
          {{t "account.controllers.groups.facebook.add_profile"}}
        </h2>
        <p>
          {{t "account.controllers.groups.facebook.add_profile_text"}}
        </p>
      </modal.card-header>
      <modal.card-body class="u--p__t__0 u--p__b__sm">
        {{#if this.isFetchingPages}}
          <div class="o--blank u--p__tb__lg">
            <Shared::LoadingSpinner />
          </div>
        {{else}}
          <ul class="u--listUnstyle">
            {{#each this.pages as |page|}}
              <Shared::Social::FacebookModal::FacebookPage
                @isRunning={{this.isAddingPage}}
                @page={{page}}
                @selectPage={{this.selectPage}}
                @selectedPage={{this.selectedPage}}
              />
            {{else}}
              <div class="o--blank u--p__0 u--p__b__lg">
                <div class="img--empty__labels"></div>
                <p class="o--blank__desc u--m__t">
                  {{t "credentials.instagram_modal.body.no_profiles_available"}}
                </p>
              </div>
            {{/each}}
          </ul>
  
        {{/if}}
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button
          @onClick={{this.closeModal}}
          @text={{t "shared_words.back"}}
          @variant="outline"
          class="u--float--left"
        />
        <Shared::Ui::Button
          @isDisabled={{this.buttonIsDisabled}}
          @promise={{task this.addPage this.selectedPage}}
          @text={{if
            this.isAddingPage
            (t "credentials.instagram_modal.footer.connecting_profile")
            (t "credentials.instagram_modal.footer.connect_profile")
          }}
          @variant="primary"
          class="u--float--right"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "+LDZQhtc",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@focusTrap\"],[[30,0,[\"closeModal\"]],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[24,0,\"o--modalCard--narrow\"]],null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.controllers.groups.facebook.add_profile\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.controllers.groups.facebook.add_profile_text\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0 u--p__b__sm\"]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"isFetchingPages\"]],[[[1,\"        \"],[10,0],[14,0,\"o--blank u--p__tb__lg\"],[12],[1,\"\\n          \"],[8,[39,3],null,null,null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,\"ul\"],[14,0,\"u--listUnstyle\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"pages\"]]],null]],null],null,[[[1,\"            \"],[8,[39,6],null,[[\"@isRunning\",\"@page\",\"@selectPage\",\"@selectedPage\"],[[30,0,[\"isAddingPage\"]],[30,2],[30,0,[\"selectPage\"]],[30,0,[\"selectedPage\"]]]],null],[1,\"\\n\"]],[2]],[[[1,\"            \"],[10,0],[14,0,\"o--blank u--p__0 u--p__b__lg\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"img--empty__labels\"],[12],[13],[1,\"\\n              \"],[10,2],[14,0,\"o--blank__desc u--m__t\"],[12],[1,\"\\n                \"],[1,[28,[35,1],[\"credentials.instagram_modal.body.no_profiles_available\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n\\n\"]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,7],[[24,0,\"u--float--left\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"closeModal\"]],[28,[37,1],[\"shared_words.back\"],null],\"outline\"]],null],[1,\"\\n      \"],[8,[39,7],[[24,0,\"u--float--right\"]],[[\"@isDisabled\",\"@promise\",\"@text\",\"@variant\"],[[30,0,[\"buttonIsDisabled\"]],[28,[37,8],[[30,0,[\"addPage\"]],[30,0,[\"selectedPage\"]]],null],[52,[30,0,[\"isAddingPage\"]],[28,[37,1],[\"credentials.instagram_modal.footer.connecting_profile\"],null],[28,[37,1],[\"credentials.instagram_modal.footer.connect_profile\"],null]],\"primary\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"page\"],false,[\"shared/modal\",\"t\",\"if\",\"shared/loading-spinner\",\"each\",\"-track-array\",\"shared/social/facebook-modal/facebook-page\",\"shared/ui/button\",\"task\"]]",
    "moduleName": "shared/components/shared/social/facebook-modal.hbs",
    "isStrictMode": false
  });
  let FacebookModalComponent = _exports.default = (_dec = (0, _service.inject)('social/facebook-auth'), (_class = (_hasRequiredTasks = /*#__PURE__*/new WeakSet(), class FacebookModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _hasRequiredTasks);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "facebookAuth", _descriptor4, this);
      _initializerDefineProperty(this, "isAddingPage", _descriptor5, this);
      _initializerDefineProperty(this, "selectedPage", _descriptor6, this);
      _defineProperty(this, "addPage", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (!this.selectedPage) {
            return;
          }
          try {
            this.isAddingPage = true;
            yield this.facebookAuth.createSocialProfile.perform(this.selectedPage);
            this.isAddingPage = false;
            this.closeModal();
          } catch (error) {
            this.isAddingPage = false;
            this.alerts.warning(this.intl.t('alerts.account.controllers.groups.facebook.add_error'));
            this.errors.log(error, {
              page: JSON.stringify(this.selectedPage)
            });
          }
        }
      }), null, "addPage", "drop"));
    }
    get isFetchingPages() {
      return this.facebookAuth.authenticate.isRunning;
    }
    get buttonIsDisabled() {
      return !this.selectedPage || this.addPage.isRunning;
    }
    get pages() {
      return this.facebookAuth.facebookPages?.filter(page => _classPrivateMethodGet(this, _hasRequiredTasks, _hasRequiredTasks2).call(this, page));
    }
    selectPage(page) {
      if (this.selectedPage?.id === page.id) {
        this.selectedPage = undefined;
      } else {
        this.selectedPage = page;
      }
    }
    closeModal() {
      this.facebookAuth.closeFacebookModal();
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "facebookAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isAddingPage", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedPage", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "selectPage", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class));
  function _hasRequiredTasks2(page) {
    if (!page.tasks) {
      return false;
    }
    const requiredTasks = ['ADVERTISE', 'ANALYZE', 'MODERATE', 'CREATE_CONTENT'];
    return requiredTasks.every(requiredTask => page.tasks.includes(requiredTask));
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FacebookModalComponent);
});